import { io } from 'socket.io-client';

// URL сервера
const URL = `${process.env.REACT_APP_SOCKET_URL}`;
const PATH = `${process.env.REACT_APP_SOCKET_PATH}`;

// export const socket = io(URL);
// Создание подключения к серверу
// возможно данный сокет нужно убрать ведь есть компоеннет connector
// export const socket = io(URL);
export const socket = io(URL, {
                            path:PATH,
                            transports: ["websocket", "polling"],
                        });
// Обработчик события сообщений
socket.on('message', msg => {console.log('socket msg', msg)})
// вызов события через сокет
socket.emit('message', 'new user connected')



